/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityLockClosedIcon16Light } from './SecurityLockClosedIcon16Light';
import { SecurityLockClosedIcon16Regular } from './SecurityLockClosedIcon16Regular';
import { SecurityLockClosedIcon16Solid } from './SecurityLockClosedIcon16Solid';
import { SecurityLockClosedIcon20Light } from './SecurityLockClosedIcon20Light';
import { SecurityLockClosedIcon20Regular } from './SecurityLockClosedIcon20Regular';
import { SecurityLockClosedIcon20Solid } from './SecurityLockClosedIcon20Solid';
import { SecurityLockClosedIcon24Regular } from './SecurityLockClosedIcon24Regular';
import { SecurityLockClosedIcon24Solid } from './SecurityLockClosedIcon24Solid';
import { SecurityLockClosedIcon32Regular } from './SecurityLockClosedIcon32Regular';
import { SecurityLockClosedIcon64Regular } from './SecurityLockClosedIcon64Regular';
var sizes = {
    16: {
        light: SecurityLockClosedIcon16Light,
        regular: SecurityLockClosedIcon16Regular,
        solid: SecurityLockClosedIcon16Solid,
    },
    20: {
        light: SecurityLockClosedIcon20Light,
        regular: SecurityLockClosedIcon20Regular,
        solid: SecurityLockClosedIcon20Solid,
    },
    24: {
        regular: SecurityLockClosedIcon24Regular,
        solid: SecurityLockClosedIcon24Solid,
    },
    32: {
        regular: SecurityLockClosedIcon32Regular,
    },
    64: {
        regular: SecurityLockClosedIcon64Regular,
    },
};
export var SecurityLockClosedIcon = forwardRef('SecurityLockClosedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
